export const loyaltyModule = {
  state: () => ({
    programs: [
      {
        id: 'mir',
        isSelected: false,
      },

      {
        id: 'uds',
        isSelected: false,
        isApplied: false,
        data: {},
      }
    ],
  }),

  getters: {
    getSelected: state => {
      return state.programs.find(obj => obj.isSelected === true) || null
    },

    getPointsToWriteOff: state => {
      let res = 0
      let udsData = state.programs.find(obj => obj.id === 'uds').data
      if(udsData && udsData.code) {
        res = udsData.canWrite
      }

      return res
    },

    getUdsData: state => {
      let result = {}
      let data = state.programs.find(obj => obj.id === 'uds')

      if(data.isSelected && data.isApplied) {
        result = data.data
      }

      return result
    },
  },

  mutations: {
    updateBonusProgram(state, payload) {
      let findedObj = state.programs.find(obj => obj.id === payload.id)
      if(findedObj) {
        Object.assign(findedObj, payload.data);
      }
    },
  },

  actions: {
    updateBonusProgram({commit}, payload) {
      commit('updateBonusProgram', payload)
    },

    // getUdsPoints({commit, rootGetters}, code) {
    //   let params = {
    //     code: code,
    //     total: rootGetters['getTotalPrice'],
    //   }

    //   console.log(params)

    //   // this._vm.$http
    //   //   .post('solar:booking.api.uds.info', params)
    // },
  },

  namespaced: true,
}
